import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        equipmentBRs: [],
        images: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        equipmentBRMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        getEquipmentBRsRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveEquipmentBRs", null);
            } else {
                dispatch("receivingEquipmentBRs"); // สถานะ กำลังบันทึก

                const formData = new FormData();
                formData.append('item_type_master_code', payload.item_type_master_code);
                // formData.append('news_type_tag', payload.news_type_tag); วันที่จะยืม
                // formData.append('news_type_tag', payload.news_type_tag); วันที่จะคืน
                axios.get('/equipment_brs', {params: payload})
                    .then(function (res) {
                        dispatch("receiveEquipmentBRs", res.data);
                    })
                    .catch(function (e) {
                        console.log(e);
                        dispatch("receiveEquipmentBRs", null);
                    });

            }
        },
        loadEquipmentBRRequest({dispatch}, id) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveEquipmentBR", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingEquipmentBR");
                axios.get('/equipment_brs/' + id).then(res => {
                    dispatch("receiveEquipmentBR", res.data);
                })
            }
        },
        updateEquipmentBRRequest({dispatch}, payload) {


            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingEquipmentBR");
            const formData = new FormData();
           // formData.append('file', payload.avatarFile);
            formData.append('borrowing_id', payload.borrowing_id);
            formData.append('user_name', payload.user_name);
            formData.append('borrowing_title', payload.borrowing_title);
            formData.append('borrowing_place_title', payload.borrowing_place_title);
            formData.append('start_date', payload.start_date);
            formData.append('end_date', payload.end_date);
            formData.append('phone_number', payload.phone_number);
            formData.append('certifier_user_name', payload.certifier_user_name);
            formData.append('borrowing_status', payload.borrowing_status);
            // formData.append('equipment_br_items', payload.equipment_br_items);
            formData.append('equipment_br_items', JSON.stringify(payload.equipment_br_items));
            formData.append('activity_id_search', payload.activity_id_search);
            formData.append('activity_id_search_history',  Array.from(payload.activity_id_search_history).join(','));

            axios.post('/update_equipment_brs', formData).then(res => {
                console.log(res)
                dispatch("updateEquipmentBR", res.data);
            })

        },
        updateStatusEquipmentBRRequest({dispatch}, payload) {

            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingEquipmentBR");
            const formData = new FormData();
            // formData.append('file', payload.avatarFile);
            formData.append('borrowing_id', payload.borrowing_id);
            formData.append('borrowing_status', payload.borrowing_status);
            formData.append('remark', payload.remark);

            axios.post('/update_status_equipment_brs', formData).then(res => {
                dispatch("updateEquipmentBR", res.data);
            })


        },
        createEquipmentBRRequest({dispatch}, payload) {

            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingEquipmentBR");

            const formData = new FormData();
            // formData.append('file', payload.avatarFile);
            formData.append('borrowing_id', payload.borrowing_id);
            formData.append('user_name', payload.user_name);
            formData.append('borrowing_title', payload.borrowing_title);
            formData.append('borrowing_place_title', payload.borrowing_place_title);
            formData.append('start_date', payload.start_date);
            formData.append('end_date', payload.end_date);
            formData.append('phone_number', payload.phone_number);
            formData.append('certifier_user_name', payload.certifier_user_name);
            formData.append('borrowing_status', payload.borrowing_status);
         //   formData.append('equipment_br_items', payload.equipment_br_items);
            formData.append('equipment_br_items', JSON.stringify(payload.equipment_br_items));
            formData.append('activity_id_search', payload.activity_id_search);
            formData.append('activity_id_search_history',  Array.from(payload.activity_id_search_history).join(','));
            axios.post('/equipment_brs', formData).then(res => {
                dispatch("receiveEquipmentBR", res.data);

            })


        },
        deleteEquipmentBRRequest({dispatch}, payload) {

            dispatch("afterDeleteEquipmentBR", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingEquipmentBR", payload);

            axios.post('/delete_equipment_brs', payload).then(res => {
                dispatch("deleteEquipmentBR", {borrowing_id: payload.borrowing_id, res: res});
            })


        },
        receiveEquipmentBRs({commit}, payload) {
            commit("RECEIVED_DATAS", payload)
        },
        receivingEquipmentBRs({commit}) {
            commit("RECEIVING_DATAS") //call matutions --> state.isReceiving = true;
        },
        receiveEquipmentBR({commit}, payload) {
            commit("RECEIVED_DATA", payload)
        },
        receivingEquipmentBR({commit}) {
            commit("RECEIVING_DATAS") //call matutions --> state.isReceiving = true;
        },
        updateEquipmentBR({commit}, payload) {
            commit("UPDATED_DATA", payload)
        },
        updatingEquipmentBR({commit}) {
            commit("UPDATING_DATA") //  call matutions --> state.isUpdating = true;
        },
        deleteEquipmentBR({commit}, payload) {
            commit("DELETED_DATA", payload)
        },
        deletingEquipmentBR({commit}, payload) {
            commit("DELETING_DATA", payload)
        },
        afterDeleteEquipmentBR({commit}, payload) {
            commit("AFFTER_DELETED_DATA", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_DATAS(state, payload) {
            state.equipmentBRs = payload;
            state.isReceiving = false;

        },
        RECEIVING_DATAS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_DATA(state, payload) {

            console.log(payload)


            if (payload.borrowing_id == undefined) {
                let error = payload.e.errorInfo == undefined ? payload.message : payload.e.errorInfo.toString()
                let equipmentBRMessage = 'พบข้อผิดพลาด :' + error;
                state = Object.assign(state, {
                    isReceiving: false,
                    equipmentBRMessage: (state.equipmentBRMessage == equipmentBRMessage ? equipmentBRMessage + ' ' : equipmentBRMessage),

                });
            } else {
                let equipmentBRMessage = 'บันทึกสำเร็จ! รายการ ' + payload.borrowing_id + ' ถูกบันทึกแล้ว';
                state = Object.assign(state, {
                    equipmentBRs: [...state.equipmentBRs, payload],
                    isReceiving: false,
                    errorMessage: false,
                    equipmentBRMessage: (state.equipmentBRMessage == equipmentBRMessage ? equipmentBRMessage + ' ' : equipmentBRMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },
        // RECEIVING_DATA(state) {
        //     state.isReceiving = true;
        // },

        UPDATED_DATA(state, payload) {
            let index = state.equipmentBRs.findIndex(p => p.borrowing_id === payload.borrowing_id);
            let equipmentBRMessage = 'บันทึกสำเร็จ! รายการ ' + payload.borrowing_id + ' ถูกแก้ไขแล้ว';

            state = Object.assign(state, {
                equipmentBRs: state.equipmentBRs.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                equipmentBRMessage: (state.equipmentBRMessage == equipmentBRMessage ? equipmentBRMessage + ' ' : equipmentBRMessage),
            })
        },
        UPDATING_DATA(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_DATA(state, payload) {
            console.log(payload)


            if (payload.res.data.borrowing_id == undefined || payload.res.data.message == 'Relation') {
                let equipmentBRMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.borrowing_id;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                    equipmentBRMessage: (state.equipmentBRMessage == equipmentBRMessage ? equipmentBRMessage + ' ' : equipmentBRMessage),

                });
            } else {
                let indexToDelete = state.equipmentBRs.findIndex(p => p.borrowing_id === payload.res.data.borrowing_id);
                let equipmentBRs = [...state.equipmentBRs];
                equipmentBRs.splice(indexToDelete, 1);
                let equipmentBRMessage = 'บันทึกสำเร็จ! รายการ ' + payload.res.data.borrowing_id + ' ถูกลบแล้ว';
                state = Object.assign(state, {
                    equipmentBRs: [...equipmentBRs],
                    isDeleting: false,
                    idToDelete: null,
                    equipmentBRMessage: (state.equipmentBRMessage == equipmentBRMessage ? equipmentBRMessage + ' ' : equipmentBRMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_DATA(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.borrowing_id;
        },
        AFFTER_DELETED_DATA(state) {
            state.errorMessage = false;

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
